/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Portada from "./Componentes/Home_Portada";
import Home_Anuncios from "./Componentes/Home_Anuncios";
import Home_Catalogo from "./Componentes/Home_Catalogo";
import Home_Lanza from "./Componentes/Home_Lanza";
import Home_Categorias from "./Componentes/Home_Categorias";
import Home_Registra from "./Componentes/Home_Registra";
import Home_Experiencia from "./Componentes/Home_Experiencia";
import Home_Refistra_Correo from "./Componentes/Home_Refistra_Correo";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Seccion_Home = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                <Home_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 8 : 14}}>
                <Home_Anuncios/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 8 : 14}}>
                <Home_Catalogo/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 8 : 14}}>
                <Home_Lanza/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Home_Categorias/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Home_Registra/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 8 : 14}}>
                <Home_Experiencia/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 8 : 18, mb: sCell ? 0 : -10}}>
                <Home_Refistra_Correo/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Home